export default __webpack_public_path__ + "static/media/Legguards of the Assailant.1d107233.jpg";